module.exports = __webpack_public_path__ + "2fd0968365b2c08744ed5d700c6a0092.png";